<template>
	<div
		style="position: fixed; min-height: 56px; width: 100%; z-index: 999;"
		class="flex justify-content-between align-items-center layout-topbar">
		<div v-if="showLogoutModal" class="logout-modal">
			<LogoutConfirmation
:display="showLogoutModal" @cancel-logout="onCancelLogout"
				@confirm-logout="onConfirmLogout" />
		</div>

		<button
v-if="false" id="menu-button" class="p-link layout-right-panel-button layout-topbar-icon"
			@click="onRightMenuButtonClick">
			<i class="pi pi-ellipsis-v" />
		</button>

		<button v-if="false" class="p-link layout-menu-button layout-topbar-icon" @click="onMenuButtonClick">
			<i class="pi pi-bars" />
		</button>

		<!--
			Marca: logo + versão à direita da imagem.
			No index do coletor, empresa/usuário ficam na linha de baixo.
		-->
		<div
			class="topbar-brand px-2 py-1"
			:class="{ 'topbar-brand--coletor-home': isColetorHome }">
			<div class="topbar-brand-logo-row">
				<img
					class="topbar-brand-logo"
					src="~assets/images/logo-harpia-wms.png"
					alt="Harpia WMS">
				<span class="topbar-brand-version">
					v{{ appVersion }}
				</span>
			</div>
			<!--
				Uma linha só: `COD - EMPRESA | COD - USUARIO`, como pedido
				para a home do coletor (não empilha em duas linhas).
			-->
			<span
				v-if="isColetorHome"
				class="topbar-brand-sessao">
				{{ textoSessao }}
			</span>
		</div>
		<div class="flex flex-row align-items-center pr-1">

			<!--
				Consultas avulsas ("B4 - Consultas" do `SIST_MAINFORM`). Ficam no topo
				do menu principal do coletor, ao lado do avatar, e não na grade de
				rotinas operacionais.

				Só aparece quando o usuário tem alguma liberada — a mesma checagem de
				permissão das demais rotinas, feita em `definirRotinasDisponiveis`.
			-->
			<button
				v-if="isColetorHome && consultas.length > 0" type="button" class="p-link botao-consulta"
				aria-label="Consultas" title="Consultas" @click="consultasVisiveis = true">
				<i class="pi pi-search" />
			</button>

			<NuxtLink v-if="false" to="/" class="p-link layout-topbar-logo">
				<img id="topbar-logo" src="~assets/images/logo-roma-white.svg" alt="roma-vue">
			</NuxtLink>
			<span v-if="pageStore.showSearchBar" class="layout-topbar-search w-full">
				<i class="pi pi-search text-700" />
				<input class="lg:w-8 md:w-4 text-700 surface-300" type="text" placeholder="Pesquise">
			</span>

			<ul class="topbar-menu">
				<li :class="['user-profile', { 'active-topmenuitem fadeInDown': props.activeTopbarItem === 'profile' }]">
					<button
v-if="!props.inlineUser" class="p-link"
						@click="$emit('topbar-item-click', { originalEvent: $event, item: 'profile' })">
						<img src="~assets/images/srWhite.png" alt="roma-layout">
						<div class="layout-profile-userinfo">
							<span class="layout-profile-name">
								{{ displayName || "—" }}
								<span v-if="userStore.userID" class="layout-profile-userid">
									| {{ userStore.userID }}
								</span>
							</span>
							<span
								v-if="userStore.companyName"
								class="layout-profile-company">
								{{ userStore.companyName }}
							</span>
						</div>
					</button>
					<transition name="layout-submenu-container">
						<ul v-show="props.activeTopbarItem === 'profile'" class="fadeInDown">
							<!--                            <li role="menuitem">-->
							<!--                                <button class="p-link">-->
							<!--                                    <i class="pi pi-fw pi-user"></i>-->
							<!--                                    <span>Profile</span>-->
							<!--                                </button>-->
							<!--                            </li>-->
							<li role="menuitem">
								<button class="p-link" @click="showConfig">
									<i class="pi pi-fw pi-cog" />
									<span>Configurações</span>
								</button>
							</li>
							<!--                            <li role="menuitem">-->
							<!--                                <button class="p-link">-->
							<!--                                    <i class="pi pi-fw pi-envelope"></i>-->
							<!--                                    <span>Messages</span>-->
							<!--                                </button>-->
							<!--                            </li>-->
							<!--                            <li role="menuitem">-->
							<!--                                <button class="p-link">-->
							<!--                                    <i class="pi pi-fw pi-bell"></i>-->
							<!--                                    <span>Notifications</span>-->
							<!--                                </button>-->
							<!--                            </li>-->
							<li role="menuItem">
								<button class="p-link" @click="onLogout">
									<i class="pi pi-fw pi-user-minus" />
									<span>Logout</span>
								</button>
							</li>
						</ul>
					</transition>
				</li>

				<!-- Sininho de notificações: oculto por enquanto (placeholder do tema). -->
				<li
					v-if="false"
					:class="[{ 'active-topmenuitem fadeInDown': props.activeTopbarItem === 'settings' }]">
					<button
v-if="props.showIcons" class="p-link layout-topbar-icon"
						@click="$emit('topbar-item-click', { originalEvent: $event, item: 'settings' })">
						<i class="topbar-icon pi pi-fw pi-bell" />
					</button>
					<transition name="layout-submenu-container">
						<ul v-show="props.activeTopbarItem === 'settings'" class="fadeInDown">
							<li role="menuitem">
								<button class="p-link">
									<img src="~assets/images/avatar-1.png" alt="roma-vue">
									<div class="topbar-menu-info">
										<span class="topbar-menu-name">Bithika Abhedananda</span>
										<span class="topbar-menu-role">User interface review is done.</span>
									</div>
								</button>
							</li>
							<li role="menuitem">
								<button class="p-link">
									<img src="~assets/images/avatar-2.png" alt="roma-vue">
									<div class="topbar-menu-info">
										<span class="topbar-menu-name">Dai Jiang</span>
										<span class="topbar-menu-role">Uh, we have sort of a problem here.</span>
									</div>
								</button>
							</li>
							<li role="menuitem">
								<button class="p-link">
									<img src="~assets/images/avatar-3.png" alt="roma-vue">
									<div class="topbar-menu-info">
										<span class="topbar-menu-name">Karlien Nijhuis</span>
										<span class="topbar-menu-role">You apparently didn’t put the thing</span>
									</div>
								</button>
							</li>
							<li role="menuitem">
								<button class="p-link">
									<img src="~assets/images/avatar-4.png" alt="roma-vue">
									<div class="topbar-menu-info">
										<span class="topbar-menu-name">Tom Chun</span>
										<span class="topbar-menu-role">Please check the files</span>
									</div>
								</button>
							</li>
							<li role="menuitem">
								<button class="p-link">
									<img src="~assets/images/avatar-5.png" alt="roma-vue">
									<div class="topbar-menu-info">
										<span class="topbar-menu-name">Maria Trofimova</span>
										<span class="topbar-menu-role">Meeting reports attached.</span>
									</div>
								</button>
							</li>
						</ul>
					</transition>
					<div />

				</li>
			</ul>
			<span v-if="deviceStore.doPing">

				<PingBall />
			</span>
		</div>

		<Dialog
			v-model:visible="consultasVisiveis" modal header="Consultas" class="dialogo-consulta"
			:draggable="false" :style="{ width: '92vw', maxWidth: '26rem' }">
			<div class="lista-consulta">
				<button
					v-for="consulta in consultas" :key="consulta.to" type="button" class="item-consulta"
					@click="abrirConsulta(consulta)">
					<span class="item-consulta-icone">
						<img v-if="iconeDaRotina(consulta.tela)" :src="iconeDaRotina(consulta.tela)!" alt="" aria-hidden="true">
						<i v-else class="pi pi-search" aria-hidden="true" />
					</span>
					<span class="item-consulta-rotulo">{{ consulta.label }}</span>
					<i class="pi pi-angle-right item-consulta-seta" aria-hidden="true" />
				</button>
			</div>
		</Dialog>

	</div>
</template>

<script lang="ts" setup>
	import type { PagesMenu } from "~/types/pagesMenu";
	import { iconeDaRotina } from "~/composables/menus/iconesRotinas";
	import { useConsultasLiberadas } from "~/composables/menus/rotinas/consulta/useRotinasConsulta";
	import { useUsuarioLogadoDisplay } from "~/composables/useUsuarioLogadoDisplay";

	const deviceStore = useDeviceStore();
	const pageStore = usePageStore();
	const userStore = useUserStore();
	const route = useRoute();
	const { logout } = useSessionManager();
	const { displayName } = useUsuarioLogadoDisplay();

	/**
	 * Home do coletor: menu principal em layout mobile.
	 * É só aí que a top bar expõe empresa/usuário sob a logo.
	 */
	const isColetorHome = computed(() => {
		const path = route.path.replace(/\/+$/, "") || "/";
		const isHome = path === "/" || path === "/index";
		if (!isHome) return false;
		return pageStore.isCollector() || deviceStore.isMobile === true;
	});

	/**
	 * Sessão na home do coletor, numa linha:
	 * `COD - EMPRESA | COD - USUARIO`
	 */
	const textoSessao = computed(() => {
		const codEmpresa = userStore.companyID != null && userStore.companyID !== 0
			? String(userStore.companyID)
			: "—";
		const descEmpresa = String(userStore.companyName ?? "").trim() || "—";

		const codUsuario = userStore.userID
			? String(userStore.userID)
			: "—";
		const nomeUsuario = String(displayName.value ?? "").trim() || "—";
		// Se o nome ainda for só o ID (não carregou DESCR_754), não repete.
		const parteUsuario = nomeUsuario === codUsuario
			? codUsuario
			: `${codUsuario} - ${nomeUsuario}`;

		return `${codEmpresa} - ${descEmpresa} | ${parteUsuario}`;
	});

	// Consultas avulsas, atrás do botão de lupa.
	const consultas = useConsultasLiberadas();
	const consultasVisiveis = ref(false);

	function abrirConsulta(consulta: PagesMenu["items"][number]) {
		consultasVisiveis.value = false;

		// Mesmo par que a grade do menu grava antes de navegar: a tela de destino
		// lê os dois do store para montar o título e o retorno.
		userStore.setCurrentPageName(consulta.label);
		if (consulta.tela) userStore.setMenuSelected(consulta.tela);

		navigateTo(consulta.to);
	}
	const emit = defineEmits(['menubutton-click', 'topbar-menubutton-click',
		'topbar-item-click', 'right-menubutton-click', 'logout-button-click']);
	const { $r3ConfiguracoesEvents } = useNuxtApp();
	const config = useRuntimeConfig();
	const appVersion = computed(() => config?.public?.VERSION ?? "");

	pageStore.setShowSearchBar(false);


	const props = defineProps<{
		topbarMenuActive: boolean,
		activeTopbarItem: string,
		inlineUser: boolean | null | undefined,
		showIcons: boolean,
		showSearch: boolean
	}>()

	const showLogoutModal = ref(false)

	function onCancelLogout() {
		showLogoutModal.value = false
	}

	async function onConfirmLogout() {
		showLogoutModal.value = false
		await logout("manual-logout")
	}

	async function onLogout(event: Event) {
		showLogoutModal.value = true

		// event.preventDefault()
	}



	function onMenuButtonClick(event: Event) {
		emit('menubutton-click', event);
	}

	function onLogoutButtonClick(event: Event) {
		localStorage.removeItem('userStore')
		emit('logout-button-click', event)
	}

	// function onTopbarMenuButtonClick(event: Event) {
	//     emit('topbar-menubutton-click', event);
	// }
	function onRightMenuButtonClick(event: Event) {
		emit('right-menubutton-click', event);
	}

	function showConfig() {
		$r3ConfiguracoesEvents.emit('show', {})
	}

</script>

<style scoped lang="scss">
	@media (max-width: 480px) {
		.layout-wrapper .layout-topbar .layout-topbar-search {
			background-color: red !important;

			input: {
				width: 100% !important
			}
		}
	}

	/* Degradê azul no top bar (invertido: escuro → claro). */
	.layout-topbar {
		background: linear-gradient(
			105deg,
			#05507f 0%,
			#0772b3 48%,
			#0a9ee0 100%
		) !important;
	}

	/* Logo à esquerda; versão logo abaixo da imagem (desktop / demais telas). */
	.topbar-brand {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		gap: 0.1rem;
		line-height: 1.15;
		color: #fff;
		min-width: 0;
	}

	/* Logo + versão na mesma linha (versão à direita da logo). */
	.topbar-brand-logo-row {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.45rem;
		min-width: 0;
	}

	/* Index do coletor: sessão (empresa/usuário) embaixo da linha logo+versão. */
	.topbar-brand--coletor-home {
		align-self: stretch;
		justify-content: center;
		max-width: min(70vw, 18rem);
		gap: 0.2rem;
	}

	.topbar-brand-logo {
		display: block;
		height: 1.65rem;
		width: auto;
		max-width: min(42vw, 14rem);
		object-fit: contain;
		flex-shrink: 0;
		/* Fundo preto da arte some na top bar colorida; o branco permanece. */
		mix-blend-mode: screen;
	}

	.topbar-brand--coletor-home .topbar-brand-logo {
		height: 1.5rem;
		max-width: min(36vw, 11rem);
	}

	.topbar-brand-version {
		font-size: 0.78rem;
		font-weight: 600;
		letter-spacing: 0.01em;
		opacity: 0.95;
		white-space: nowrap;
		line-height: 1;
	}

	/* `COD - EMPRESA | COD - USUARIO` — uma linha, com reticências se apertar. */
	.topbar-brand-sessao {
		display: block;
		min-width: 0;
		width: 100%;
		padding-left: 0.05rem;
		font-size: 0.72rem;
		font-weight: 600;
		line-height: 1.25;
		color: #ffffff;
		opacity: 0.98;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.layout-profile-userid {
		font-weight: 500;
		opacity: 0.9;
	}

	/* Empresa abaixo do nome do usuário — branco para contrastar na top bar azul. */
	.layout-profile-company {
		display: block;
		margin-top: 0.1rem;
		font-size: 0.72rem;
		font-weight: 500;
		color: #ffffff !important;
		opacity: 1;
		max-width: min(40vw, 16rem);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: left;
	}

	/* Garante nome e código brancos no perfil (tema às vezes herda cor escura). */
	:deep(.layout-profile-name),
	:deep(.layout-profile-userid) {
		color: #ffffff !important;
	}

	/* Alvo generoso: o operador aciona de luva, com o coletor na mão. */
	.botao-consulta {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 2.75rem;
		height: 2.75rem;
		margin-right: 0.25rem;
		border-radius: 50%;
		color: #fff;

		i {
			font-size: 1.35rem;
		}

		&:hover,
		&:focus-visible {
			background: rgba(255, 255, 255, 0.16);
		}
	}

	.lista-consulta {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}

	.item-consulta {
		display: flex;
		align-items: center;
		gap: 0.85rem;
		width: 100%;
		padding: 0.7rem 0.9rem;
		background: var(--surface-card, #fff);
		border: 1px solid var(--surface-border, #dfe4e8);
		border-radius: 8px;
		color: inherit;
		font: inherit;
		font-size: 1.05rem;
		text-align: left;
		cursor: pointer;

		&:hover,
		&:focus-visible {
			border-color: var(--primary-color, #1789bf);
		}
	}

	.item-consulta-icone {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 2.5rem;
		height: 2.5rem;
		border-radius: 8px;
		background: var(--surface-100, #f1f4f6);

		img {
			width: 1.9rem;
			height: 1.9rem;
			object-fit: contain;
		}

		i {
			font-size: 1.2rem;
			color: var(--primary-color, #1789bf);
		}
	}

	.item-consulta-rotulo {
		flex: 1;
	}

	.item-consulta-seta {
		color: var(--text-color-secondary, #6c7a86);
	}
</style>
